<template>
  <div class="w-100">
    <d-alert
      v-if="!loaded && !loadError"
      show
      theme="light"
      class="text-center">
      {{ $t('ui.dataLoading') }}&hellip;
    </d-alert>

    <d-alert
      v-if="loadError"
      show
      theme="warning"
      class="text-center">
      {{ $t('ui.dataLoadingFailed') }}&hellip;
    </d-alert>

    <template v-if="loaded && !loadError">
      <d-alert
        v-if="!editions.length"
        show
        theme="warning"
        class="text-center">
        {{ $t('customer.historyNoRecords') }}
      </d-alert>

      <table
        v-else
        class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('customer.historyDate') }}</th>
            <th scope="col" class="border-0">{{ $t('customer.historyAction') }}</th>
            <th scope="col" class="border-0">{{ $t('customer.historyModifiedElement') }}</th>
            <th scope="col" class="border-0">{{ $t('customer.historyUser') }}</th>
            <th scope="col" class="border-0">{{ $t('customer.historyActions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of editions"
            :key="'edition-history-row-' + index">
            <td>
              {{ row.created_at.replace('T', ' ').replace('.000000Z', '') }}
            </td>
            <td>
              <d-badge
                :theme="row.action === 'ADD' ? 'success' : (row.action === 'UPDATE' ? 'warning' : (row.action === 'DELETE' ? 'danger' : 'gray'))">
                {{ $t('customer.historyActionsList.' + row.action) }}
              </d-badge>
            </td>
            <td>
              {{ $t('customer.historyModifiedElementsList.' + row.source_type) }}
            </td>
            <td>
              {{ row.user_name }}
            </td>
            <td>
              <d-button
                v-if="row.action === 'UPDATE'"
                theme="warning"
                @click.prevent="openHistoryItemDifferencesPopup(row.id)">
                {{ $t('customer.historySeeChanges') }}
              </d-button>
            </td>
          </tr>
        </tbody>
      </table>

      <pagination
        :meta-data="paginationMetaData"
        :initial-page="currentPage" />
    </template>

    <customer-history-item-differences-popup
      v-if="showHistoryDiffPopup"
      :historyItemIdToLoad="historyItemIdToLoad" />
  </div>
</template>

<script>
import CustomerHistoryItemDifferencesPopup from './CustomerHistoryItemDifferencesPopup.vue';
import CustomerPanel from './../../mixins/CustomerPanel.vue';
import debounce from 'lodash.debounce';
import ListUtils from './../../utils/ListUtils.js';
import HasPagination from './../../mixins/HasPagination.vue';
import Pagination from './../common/Pagination.vue';

export default {
  name: 'customer-editions',
  mixins: [
    CustomerPanel,
    HasPagination
  ],
  props: [
    'customerID'
  ],
  components: {
    'customer-history-item-differences-popup': CustomerHistoryItemDifferencesPopup,
    'pagination': Pagination
  },
  data () {
    return {
      editions: [],
      loaded: false,
      loadError: false,
      showHistoryDiffPopup: false,
      historyItemIdToLoad: false
    };
  },
  mounted () {
    this.debouncedLoadFilteredData();
    this.$bus.$on('customer-history-item-differences-close', this.closeHistoryItemDifferencesPopup);
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      ListUtils.loadPaginatedItemsData(this, {
        endpoint: this.getApiEndpoint('/customers/editions/items?where[customer_id]=' + this.customerID + '&page=' + this.currentPage),
        method: 'get',
        listField: 'editions'
      });
    },
    openHistoryItemDifferencesPopup (idToLoad) {
      this.showHistoryDiffPopup = true;
      this.historyItemIdToLoad = idToLoad;
    },
    closeHistoryItemDifferencesPopup () {
      this.showHistoryDiffPopup = false;
      this.historyItemIdToLoad = false;
    },
  },
  beforeDestroy () {
    this.$bus.$off('customer-history-item-differences-close', this.closeHistoryItemDifferencesPopup);
  }
}
</script>

<style lang="scss">

</style>
